import Image from 'next/image';

import { CustomLink } from './custom-link';

type LogoType = 'default' | 'white';
type LogoSize = 'default' | 'square';

function LogoImage({
  className,
  logoType = 'default',
  logoSize = 'default',
}: {
  className?: string;
  logoSize?: LogoSize;
  logoType?: LogoType;
}) {
  let baseSrc =
    logoSize == 'square'
      ? '/images/logo-narrafix-square'
      : '/images/logo-narrafix';
  if (logoType == 'default') {
    baseSrc += '.svg';
  } else {
    baseSrc += '-white.svg';
  }

  const width = logoSize == 'square' ? 37 : 300;
  const height = logoSize == 'square' ? 28 : 63;

  return (
    <Image
      priority
      width={width}
      height={height}
      src={baseSrc}
      alt={`narrafix logo`}
      className={className}
    />
  );
}

export function AppLogo({
  href,
  label,
  className,
  logoType = 'default',
  logoSize = 'default',
}: {
  href?: string | null;
  className?: string;
  label?: string;
  logoType?: LogoType;
  logoSize?: LogoSize;
}) {
  if (href === null) {
    return (
      <LogoImage
        className={className}
        logoType={logoType}
        logoSize={logoSize}
      />
    );
  }

  return (
    <CustomLink aria-label={label ?? 'Home Page'} href={href ?? '/'}>
      <LogoImage
        className={className}
        logoType={logoType}
        logoSize={logoSize}
      />
    </CustomLink>
  );
}
